<ng-container *ngIf="isDragAndDropHiddenXOverflow">
  
  <div #parent style="height: 100%; max-height: 100%; overflow-y: auto; overflow-x: hidden; display: flex; flex-direction: column; position: relative; width: 100%;" [attr.data-cy]="cypressControlIdentifier">
    <app-tdo-search #search *ngIf="isSearchable === true" style="width: 70%; flex-basis: 60px; position: relative; top: 10px;"
                    (searchChange)="applySearchFilter($event)" placeholder="Search"></app-tdo-search>
    <div *ngIf="isAddButtonEnabled || label.length > 0" style="background-color: var(--tdo-secondary); color: white; flex-basis: 20px; width: 100%; display: flex;">
      <div style="flex: 1; font-size: 18px; font-weight: 500; margin-left: 8px; margin-top: 6px;">{{label}}</div>
      <button matTooltip="Add" mat-icon-button style="cursor: pointer; flex-basis: 40px; color: white; position: relative; bottom: 0;" (click)="onAddClick($event)" [attr.data-cy]="cypressControlAddButtonIdentifier"><mat-icon>add_box</mat-icon></button>
    </div>
    <div style="border-bottom: 1px solid rgba(0,0,0,0.05); overflow-y: auto; flex: 1; max-height: 100%; width: 100%;">
      <table #table style="width: 100%; overflow-y: auto; overflow-x: auto; font-size: x-small;" mat-table matSort 
             [matSortActive]="sortActive" [matSortDirection]="sortDirection" [matSortDisabled]="true" [dataSource]="matDataSource"
             cdkDropList
             (contentChanged)="onTableContentChanged()"
             [cdkDropListData]="matDataSource"
             (cdkDropListDropped)="onDropRow($event)">
        <ng-container *ngIf="HasRowNumbers" matColumnDef="rowNumber">
          <th mat-header-cell *matHeaderCellDef> #</th>
          <td mat-cell *matCellDef="let element"> {{ element.rowNumber }} </td>
        </ng-container>
        <ng-container *ngFor="let item of tdoColumns; index as i">
          <ng-container [matColumnDef]="item.propertyName">
            <ng-container *ngIf="item.isSortable">
              <th [ngClass]="{'custom-header': item.headerTemplate}" #th mat-header-cell *matHeaderCellDef mat-sort-header="">
                <ng-container *ngIf="item.headerTemplate"
                              [ngTemplateOutlet]="item.headerTemplate"
                              [ngTemplateOutletContext]="{ $implicit: item, index: i}">
                </ng-container>
                <ng-container *ngIf="!item.headerTemplate">
                  {{item.displayName}}
                </ng-container>
              </th>
            </ng-container>
            <ng-container *ngIf="!item.isSortable">
              <th #th mat-header-cell *matHeaderCellDef>
                <ng-container *ngIf="item.headerTemplate"
                              [ngTemplateOutlet]="item.headerTemplate"
                              [ngTemplateOutletContext]="{ $implicit: item, index: i}">
                </ng-container>
                <ng-container *ngIf="!item.headerTemplate">
                  {{item.displayName}}
                </ng-container>
              </th>
            </ng-container>
            <td #cellData mat-cell *matCellDef="let row">
              <ng-container
                [ngTemplateOutlet]="item.rowTemplate"
                [ngTemplateOutletContext]="{ $implicit: row, index: i}">
              </ng-container>
            </td>
            <ng-container *ngIf="footerData && footerData.length > 0">
              <td mat-footer-cell *matFooterCellDef>
                {{footerData[i].value}}
              </td>
            </ng-container>
          </ng-container>
        </ng-container>
        <tr mat-header-row *matHeaderRowDef="displayedColumns; sticky: isStickyHeader;"></tr>
        <ng-container *ngIf="isDragAndDrop">
          <tr mat-row *matRowDef="let row; columns: displayedColumns;" (click)="onRowSelected($event, row)" (contextmenu)="onRowContextMenu($event, row); false"
              [ngClass]="{hovered: row.hovered, highlighted: selectionControl?.isSelected(row)}" style="cursor: move;"
              (mouseover)="row.hovered = true" (mouseout)="row.hovered = false" cdkDrag [cdkDragData]="row"></tr>
        </ng-container>
        <ng-container *ngIf="!isDragAndDrop">
          <tr mat-row *matRowDef="let row; columns: displayedColumns;" (click)="onRowSelected($event, row)" (contextmenu)="onRowContextMenu($event, row); false"
              [ngClass]="{hovered: row.hovered, highlighted: selectionControl?.isSelected(row)}"
              (mouseover)="row.hovered = true" (mouseout)="row.hovered = false"></tr>
        </ng-container>
        <ng-container *ngIf="footerData && footerData.length > 0">
          <tr mat-footer-row *matFooterRowDef="displayedColumns; sticky: true"></tr>
        </ng-container>
        <tr class="mat-row" *matNoDataRow>
          <td class="mat-cell" colspan="40">{{noDataMessage}}</td>
        </tr>
      </table>
    </div>
    <div #paginatorView style="height: fit-content; flex-basis: fit-content; border-bottom: 1px solid rgba(0,0,0,0.05);">
      <ng-container *ngIf="isUsePaginator === true">
        <ng-container *ngIf="pageSizeOptions !== undefined; else singlePageSize"> 
          <mat-paginator style="flex-basis: fit-content;" [pageSizeOptions]="pageSizeOptions"></mat-paginator>
        </ng-container>
        <ng-template #singlePageSize>
          <mat-paginator style="flex-basis: fit-content;" [pageSize]="pageSize"></mat-paginator>
        </ng-template>
      </ng-container>
    </div>
  </div>
</ng-container>
<ng-container *ngIf="isDragAndDrop">
  
  <div #parent style="height: 100%; max-height: 100%; overflow-y: auto; display: flex; flex-direction: column; position: relative; width: 95%;" [attr.data-cy]="cypressControlIdentifier">
    <app-tdo-search #search *ngIf="isSearchable === true" style="width: 70%; flex-basis: 60px; position: relative; top: 10px;"
                    (searchChange)="applySearchFilter($event)" placeholder="Search"></app-tdo-search>
    <div *ngIf="isAddButtonEnabled || label.length > 0" style="background-color: var(--tdo-secondary); color: white; flex-basis: 20px; width: 99%; display: flex;">
      <div style="flex: 1; font-size: 18px; font-weight: 500; margin-left: 8px; margin-top: 6px;">{{label}}</div>
      <button matTooltip="Add" mat-icon-button style="cursor: pointer; flex-basis: 40px; color: white; position: relative; bottom: 0;" (click)="onAddClick($event)" [attr.data-cy]="cypressControlAddButtonIdentifier"><mat-icon>add_box</mat-icon></button>
    </div>
    <div style="border-bottom: 1px solid rgba(0,0,0,0.05); overflow-y: auto; flex: 1; max-height: 100%; width: 99%;">
      <table #table style="width: 100%; overflow-y: auto; overflow-x: auto; font-size: x-small;" mat-table matSort 
             [matSortActive]="sortActive" [matSortDirection]="sortDirection" [matSortDisabled]="true" [dataSource]="matDataSource"
             cdkDropList
             (contentChanged)="onTableContentChanged()"
             [cdkDropListData]="matDataSource"
             (cdkDropListDropped)="onDropRow($event)">
        <ng-container *ngIf="HasRowNumbers" matColumnDef="rowNumber">
          <th mat-header-cell *matHeaderCellDef> #</th>
          <td mat-cell *matCellDef="let element"> {{ element.rowNumber }} </td>
        </ng-container>
        <ng-container *ngFor="let item of tdoColumns; index as i">
          <ng-container [matColumnDef]="item.propertyName">
            <ng-container *ngIf="item.isSortable">
              <th [ngClass]="{'custom-header': item.headerTemplate}" #th mat-header-cell *matHeaderCellDef mat-sort-header="">
                <ng-container *ngIf="item.headerTemplate"
                              [ngTemplateOutlet]="item.headerTemplate"
                              [ngTemplateOutletContext]="{ $implicit: item, index: i}">
                </ng-container>
                <ng-container *ngIf="!item.headerTemplate">
                  {{item.displayName}}
                </ng-container>
              </th>
            </ng-container>
            <ng-container *ngIf="!item.isSortable">
              <th #th mat-header-cell *matHeaderCellDef>
                <ng-container *ngIf="item.headerTemplate"
                              [ngTemplateOutlet]="item.headerTemplate"
                              [ngTemplateOutletContext]="{ $implicit: item, index: i}">
                </ng-container>
                <ng-container *ngIf="!item.headerTemplate">
                  {{item.displayName}}
                </ng-container>
              </th>
            </ng-container>
            <td #cellData mat-cell *matCellDef="let row">
              <ng-container
                [ngTemplateOutlet]="item.rowTemplate"
                [ngTemplateOutletContext]="{ $implicit: row, index: i}">
              </ng-container>
            </td>
            <ng-container *ngIf="footerData && footerData.length > 0">
              <td mat-footer-cell *matFooterCellDef>
                {{footerData[i].value}}
              </td>
            </ng-container>
          </ng-container>
        </ng-container>
        <tr mat-header-row *matHeaderRowDef="displayedColumns; sticky: isStickyHeader;"></tr>
        <ng-container *ngIf="isDragAndDrop">
          <tr mat-row *matRowDef="let row; columns: displayedColumns;" (click)="onRowSelected($event, row)" (contextmenu)="onRowContextMenu($event, row); false"
              [ngClass]="{hovered: row.hovered, highlighted: selectionControl?.isSelected(row)}" style="cursor: move;"
              (mouseover)="row.hovered = true" (mouseout)="row.hovered = false" cdkDrag [cdkDragData]="row"></tr>
        </ng-container>
        <ng-container *ngIf="!isDragAndDrop">
          <tr mat-row *matRowDef="let row; columns: displayedColumns;" (click)="onRowSelected($event, row)" (contextmenu)="onRowContextMenu($event, row); false"
              [ngClass]="{hovered: row.hovered, highlighted: selectionControl?.isSelected(row)}"
              (mouseover)="row.hovered = true" (mouseout)="row.hovered = false"></tr>
        </ng-container>
        <ng-container *ngIf="footerData && footerData.length > 0">
          <tr mat-footer-row *matFooterRowDef="displayedColumns; sticky: true"></tr>
        </ng-container>
        <tr class="mat-row" *matNoDataRow>
          <td class="mat-cell" colspan="40">{{noDataMessage}}</td>
        </tr>
      </table>
    </div>
    <div #paginatorView style="height: fit-content; flex-basis: fit-content; border-bottom: 1px solid rgba(0,0,0,0.05); width: 99%;">
      <ng-container *ngIf="isUsePaginator === true">
        <ng-container *ngIf="pageSizeOptions !== undefined; else singlePageSize"> 
          <mat-paginator style="flex-basis: fit-content;" [pageSizeOptions]="pageSizeOptions"></mat-paginator>
        </ng-container>
        <ng-template #singlePageSize>
          <mat-paginator style="flex-basis: fit-content;" [pageSize]="pageSize"></mat-paginator>
        </ng-template>
      </ng-container>
    </div>
  </div>
</ng-container>
<ng-container *ngIf="!isDragAndDrop">

  
  <div #parent style="height: 100%; max-height: 100%; overflow: hidden; display: flex; flex-direction: column; position: relative; width: 100%;" [attr.data-cy]="cypressControlIdentifier">
    <app-tdo-search #search *ngIf="isSearchable === true" style="width: 70%; flex-basis: 60px; position: relative; top: 10px;"
                    (searchChange)="applySearchFilter($event)" placeholder="Search"
                    [initialSearchValue]="searchInputValue"
    ></app-tdo-search>
    <div *ngIf="isAddButtonEnabled || label.length > 0" style="background-color: var(--tdo-secondary); color: white; flex-basis: 20px; width: 100%; display: flex;">
      <div style="flex: 1; font-size: 18px; font-weight: 500; margin-left: 8px; margin-top: 6px;">{{label}}</div>
      <button matTooltip="Add" mat-icon-button style="cursor: pointer; flex-basis: 40px; color: white; position: relative; bottom: 0;" (click)="onAddClick($event)" [attr.data-cy]="cypressControlAddButtonIdentifier"><mat-icon>add_box</mat-icon></button>
    </div>
    <div style="border-bottom: 1px solid rgba(0,0,0,0.05); overflow-y: auto; flex: 1; max-height: 100%; width: 100%;">
      <table style="width: 100%; overflow-y: hidden;" mat-table matSort (matSortChange)="sortChange($event)"
             [matSortActive]="sortActive" [matSortDirection]="sortDirection" [dataSource]="matDataSource">
        <ng-container *ngIf="HasRowNumbers" matColumnDef="rowNumber">
          <th mat-header-cell *matHeaderCellDef> #</th>
          <td mat-cell *matCellDef="let element"> {{ element.rowNumber }} </td>
        </ng-container>
        <ng-container *ngFor="let item of tdoColumns; index as i">
          <ng-container [matColumnDef]="item.propertyName">
            <ng-container *ngIf="item.isSortable">
              <th #th mat-header-cell *matHeaderCellDef mat-sort-header="">
                <ng-container *ngIf="item.headerTemplate"
                              [ngTemplateOutlet]="item.headerTemplate"
                              [ngTemplateOutletContext]="{ $implicit: item, index: i}">
                </ng-container>
                <ng-container *ngIf="!item.headerTemplate">
                  {{item.displayName}}
                </ng-container>
              </th>
            </ng-container>
            <ng-container *ngIf="!item.isSortable">
              <th #th mat-header-cell *matHeaderCellDef>
                <ng-container *ngIf="item.headerTemplate"
                              [ngTemplateOutlet]="item.headerTemplate"
                              [ngTemplateOutletContext]="{ $implicit: item, index: i}">
                </ng-container>
                <ng-container *ngIf="!item.headerTemplate">
                  {{item.displayName}}
                </ng-container>
              </th>
            </ng-container>
            <td #cellData mat-cell *matCellDef="let row">
              <ng-container
                [ngTemplateOutlet]="item.rowTemplate"
                [ngTemplateOutletContext]="{ $implicit: row, index: i}">
              </ng-container>
            </td>
            <ng-container *ngIf="footerData && footerData.length > 0">
              <td mat-footer-cell *matFooterCellDef [style]="footerData[i].tdStyle">
                {{footerData[i].value}}
              </td>
            </ng-container>
          </ng-container>
        </ng-container>
        <tr mat-header-row *matHeaderRowDef="displayedColumns; sticky: isStickyHeader;"></tr>
        <ng-container *ngIf="isDragAndDrop">
          <tr mat-row *matRowDef="let row; columns: displayedColumns;" (click)="onRowSelected($event, row)" (contextmenu)="onRowContextMenu($event, row); false"
              [ngClass]="{hovered: row.hovered, highlighted: selectionControl?.isSelected(row)}" style="cursor: move;"
              (mouseover)="row.hovered = true" (mouseout)="row.hovered = false" cdkDrag [cdkDragData]="row"></tr>
        </ng-container>
        <ng-container *ngIf="!isDragAndDrop">
          <tr mat-row *matRowDef="let row; columns: displayedColumns;" (click)="onRowSelected($event, row)" (contextmenu)="onRowContextMenu($event, row); false"
              [ngClass]="{hovered: row.hovered, highlighted: selectionControl?.isSelected(row)}"
              (mouseover)="row.hovered = true" (mouseout)="row.hovered = false"></tr>
        </ng-container>
        <ng-container *ngIf="footerData && footerData.length > 0">
          <tr mat-footer-row *matFooterRowDef="displayedColumns; sticky: true"></tr>
        </ng-container>
        <tr class="mat-row" *matNoDataRow>
          <td class="mat-cell" colspan="40">{{noDataMessage}}</td>
        </tr>
      </table>
    </div>
    <div #paginatorView style="height: fit-content; flex-basis: fit-content; border-bottom: 1px solid rgba(0,0,0,0.05);">
      <ng-container *ngIf="isUsePaginator === true">
        <ng-container *ngIf="pageSizeOptions !== undefined; else singlePageSize">
          <mat-paginator style="flex-basis: fit-content;" [pageSizeOptions]="pageSizeOptions"></mat-paginator>
        </ng-container>
        <ng-template #singlePageSize>
          <mat-paginator style="flex-basis: fit-content;" [pageSize]="pageSize"></mat-paginator>
        </ng-template>
      </ng-container>
    </div>
  </div>
</ng-container>
